import { useSession } from "@/context/Session";
import { presetFor } from "@/lib/presets";
import { t } from "@/i18n";

const todayKey = () => `smboi-special-${new Date().toDateString()}`;

export const specialDue = () => !localStorage.getItem(todayKey());

export function SpecialPrompt({ onRecord, onDismiss }: { onRecord: () => void; onDismiss: () => void }) {
  const Icon = presetFor(useSession().me.org?.preset).specialIcon;
  const close = (fn: () => void) => () => { localStorage.setItem(todayKey(), "1"); fn(); };
  const hour = new Date().getHours();
  const hello = hour < 12 ? "Good morning!" : hour < 18 ? "Good afternoon!" : "Hi there!";
  return (
    <div className="flex items-end gap-2 rise" data-testid="special-prompt">
      <img src="/mascot.png" alt="" className="h-12 w-auto shrink-0" />
      <div className="bubble-in max-w-[80%] stack-sm">
        <p className="text-[0.97rem]"><b>{t(hello)}</b> {t("Want to record today's special?")}</p>
        <div className="flex gap-2">
          <button className="btn btn-sm !bg-[var(--status-ok)] text-white" onClick={close(onRecord)} data-testid="special-record-button"><Icon size={14} /> {t("Record special")}</button>
          <button className="btn btn-ghost btn-sm" onClick={close(onDismiss)} data-testid="special-dismiss-button">{t("Not today")}</button>
        </div>
      </div>
    </div>
  );
}
